
/* Easy - Normal - Hard word sets
–––––––––––––––––––––––––––––––––––––––––––––––––– */

const wordlist = [

	[
		'Shape', 'Pursue', 'Permit', 'Frost', 'Agree', 'Airport', 'Generic', 'Good', 'Guide', 'Holder', 'Deep',
		'House', 'Lover', 'Songs', 'Error', 'Visits', 'Pixel', 'Quad', 'Wondered', 'Rogue', 'Squawk', 
		'Friday', 'Button', 'Charts', 'Colours', 'Crushed', 'Farmer', 'Horror', 'Help','Mass', 'Opened', 'Football',
		'Opinion', 'Summer', 'Sale', 'Form', 'Show', 'Sister', 'Solar', 'Happy', 'Added', 'Begun', 'Contact', 
		'Cookie', 'Custom', 'Easily', 'Level', 'Penny', 'Rebel', 'Shirt', 'Tale', 'Take', 'Video', 'Waves', 'Comics', 
		'Giant', 'Local', 'Pilot', 'Respect', 'Brief', 'Could', 'Great', 'Problem', 'Number', 'Which', 'Power',
		'Time', 'Want', 'Leave', 'Place', 'Other', 'Brain', 'Accurate', 'Again', 'Bookkeeper', 'Barren', 'Letters', 'Looking',
		'Deed', 'Balloon', 'Succeed', 'Tattoo', 'Look', 'Wheel', 'Attack', 'Feel', 'Friend', 'Loose', 'Zookeeper', 'Nerve',
		'Passenger', 'Resistance', 'Screen', 'Bass', 'Ballroom'
	],
	[
		'Raccoon', 'Bagpipes', 'Succeeds', 'Groups', 'Voodoo', 'Troubled', 'Judgment', 'Complete', 'Jukebox', 'Mixture',
		'Memento', 'Mystify', 'Cookies', 'Oxygen', 'Pajamas', 'Pixel', 'Rhythmic', 'Rogue', 'Power', 'House', 'Torso',
		'Waxy', 'Effect', 'Possibillity', 'Zombie', 'Cultural', 'Idea', 'Contrast', 'Delegation', 'Easy',
		'Levels', 'Networks', 'Looking', 'Proposal', 'Programme', 'Reserved', 'Welcomed', 'Argument', 'Biological', 'Carefully',
		'Cheaper', 'Command', 'Complaint', 'Energy', 'Queen', 'Increases', 'Innocent', 'Newspaper', 'Observed', 
		'Qualified', 'Respective', 'Creator', 'Auto', 'Rookie', 'Animal', 'Frozen', 'Secure', 'Window', 'Wisdom', 'Good', 
		'Buttons', 'Time', 'Letters', 'Penny', 'Address', 'Balloon', 'Tattoo', 'Wheel', 'Account', 'Bathroom', 
		'Special', 'Affair', 'Annual', 'Attack', 'Bottom', 'Channel', 'Commit', 'Creation', 'Feeling', 'Football', 'Limit',
		'Reference', 'Succeed', 'Wheels', 'Performance', 'Promising', 'Households', 'Buffalo', 'Unhappy', 'Toffee', 'Success',
		'Ballroom', 'Radio'
	],
	[
		'Aggressive', 'Arguments', 'Childhood', 'Excessive', 'Croquet', 'Crypt', 'Dwarves', 'Fishhook', 'Jukebox', 'Kayak',
		'Memento', 'Mystify', 'Government', 'Oxygen', 'Pajamas', 'Pixel', 'Quad', 'Rhythmic', 'Occasional', 'Ambassador',
		'Rogue', 'Squawk', 'Quiet', 'Wildebeest', 'Yacht', 'Zealous', 'Zigzag', 'Zombie', 'Quarterly', 'Unexpected', 'Frustrated',
		'Headlines', 'Households', 'Membership', 'Numerous', 'Prevention', 'Protection', 'Repeatedly', 'Virtually', 'Characters',
		'Citizen', 'Colleague', 'Effective', 'Excellent', 'Meaningful', 'Multimedia', 'Promising', 'Situations', 'Associates',
		'Commercial', 'Decisions', 'Equivalent', 'Impression', 'Philosophy', 'Presenting', 'Ultimate', 'Designated', 'Quick',
		'Creature', 'Education', 'Commission', 'Buffalo', 'Manage', 'Numerous', 'Opinion', 'Photograph', 'Pollution', 'Performance',
		'Embarrassment', 'Pizza', 'Noodle', 'Session', 'Zeal', 'Command', 'Reference', 'Succeed', 'Spokesman', 'Roommate'
	],
	[
		'Determination', 'Aggressive', 'Arguments', 'Anniversary', 'Excessive', 'Croquet', 'Christianity', 'Dwarves', 'Availability', 
		'Jukebox', 'Kayak', 'Memento', 'Mystify', 'Numbskull', 'Oxygen', 'Pajamas', 'Imagination', 'Foreclosure', 'Rhythmic', 
		'Occasional', 'Ambassador', 'Rogue', 'Squawk', 'Interpretation', 'Wildebeest', 'Yacht', 'Zealous', 'Zigzag', 'Accordingly', 
		'Quarterly', 'Unexpected', 'Frustrated', 'Headlines', 'Households', 'Membership', 'Numerous', 'Prevention', 'Protection', 
		'Repeatedly', 'Virtually', 'Characters', 'Citizen', 'Colleague', 'Effective', 'Excellent', 'Meaningful', 'Multimedia', 
		'Promising', 'Situations', 'Associates', 'Commercial', 'Decisions', 'Equivalent', 'Impression', 'Philosophy', 'Presenting', 
		'Ultimate', 'Designated', 'Portfolio', 'Dimension', 'Education', 'Fundamental', 'Performance', 'Photographer', 'Yacht'
	]
		
]
export default wordlist


